/* eslint-disable max-len */
/* eslint-disable react/jsx-one-expression-per-line */
import React, { useEffect } from 'react';
import {
  Box, Grid, makeStyles, Typography, useMediaQuery, useTheme,
} from '@material-ui/core';
import Slider from 'react-slick';
import womanInOnlineMeetingsimageMobile from '../../static/images/woman-in-online-meetings-mobile.png';

import SwitchAccountantHero from '../organisms/SwitchAccountantHero';
import FeaturesSectionSwitchAccountant from '../organisms/FeaturesSectionSwitchAccountant';
import StepByStepSection from '../organisms/StepByStepSection';
import PlansCard from '../organisms/PlansCard';
import usePurpleFriday from '../../themes/usePurpleFriday';
import AccountingFeature from '../organisms/AccountingFeatures';
import PatenerCard from '../molecules/PatenerCard';
import AccordeonList from '../molecules/AccordeonList';
import MobileHowMuchSlider from '../organisms/MobileHowMuchSlider';
import SwitchAccountantHeroMobile from '../organisms/SwitchAccountantHeroMobile';
import StyledButton from '../atoms/StyledButton';
import socio01Image from '../../static/images/socio-01.png';
import socio02Image from '../../static/images/socio-02.png';
import socio03Image from '../../static/images/socio-03.png';
import socio04Image from '../../static/images/socio-04.png';
import socio05Image from '../../static/images/socio-05.png';
import socio06Image from '../../static/images/socio-06.png';
import womanInOnlineMeetingsimage from '../../static/images/woman-in-online-meetings.png';
import ModalSwitchAccountant from '../organisms/ModalSwitchAccountantMobile';
import TextWithButtonSession from '../molecules/TextWithButtonSession';
import ContentWrap from '../atoms/ContentWrap';
import ButtonSwitchAccountantSectionMobile from '../organisms/ButtonSwitchAccountantSectionMobile';
import { addTagFirebaseAnalytcs, tagsAnalytcs } from '../../analytcs/firebase';

const useStyles = makeStyles((theme) => ({
  whatsappButton: {
    position: 'fixed',
    bottom: '100px',
    right: '0px',
    zIndex: '1000',
    padding: '5px',
    width: '60px',
    borderTopLeftRadius: '20px',
    borderBottomLeftRadius: '20px',
    backgroundColor: '#2c3e50',

    '@media screen and (max-width: 959px)': {
      width: '50px',
      bottom: '120px',
      right: '0px',
    },
  },
  whatsappButtonIcon: {
    width: '40px',
    height: '40px',
    left: '20px',

    '@media screen and (max-width: 959px)': {
      width: '35px',
      height: '35px',
    },
  },
  sliderMobile: {
    maxWidth: '400px',
    '& .slick-slide > div': {
      display: 'flex',
      justifyContent: 'center',
    },
    '& .slick-list': {
    },

    '& .slick-dots li button': {
      marginTop: '28px',
      width: '12px',
      height: '12px',
      padding: 0,
      display: 'block',
      background: 'transparent',
      border: '1px solid',
      borderColor: (props) => props.color,
      borderRadius: '50%',
      opacity: 0.5,
    },

    '& .slick-dots li button:before': {
      display: 'none',
    },

    '& .slick-dots li.slick-active button': {
      backgroundColor: (props) => props.color,
      borderColor: (props) => props.color,
      opacity: 1,
    },
  },
  slider: {
    marginTop: '25px',
    maxWidth: '1152px',
    '& .slick-slide > div': {
      margin: '0 5px',
    },
    '& .slick-list': {
      margin: '0 -5px',
    },

    '& .slick-dots li button': {
      marginTop: '28px',
      width: '12px',
      height: '12px',
      padding: 0,
      display: 'block',
      background: 'transparent',
      border: '1px solid',
      borderColor: (props) => props.color,
      borderRadius: '50%',
      opacity: 0.5,
    },

    '& .slick-dots li button:before': {
      display: 'none',
    },

    '& .slick-dots li.slick-active button': {
      backgroundColor: (props) => props.color,
      borderColor: (props) => props.color,
      opacity: 1,
    },
  },
  contractButton: {
    backgroundColor: '#0092f5',
    color: '#fff',
    '&:hover': {
      backgroundColor: '#0078c8',
    },
  },
}));

const renderList = [
  {
    title: 'Quando posso trocar a minha contabilidade pela Conube?',
    description: 'A qualquer momento você pode fazer a opção de migrar a contabilidade da sua empresa. A partir do mês seguinte ao que você preencher os dados e enviar os documentos necessários, a responsabilidade contábil da sua empresa passa a ser da Conube.',
  },
  {
    title: 'Para trocar de contador, preciso enviar meus documentos de forma física?',
    description: 'Você poderá enviar tudo que precisa de forma digital. É simples e rápido. Não há a necessidade de nos enviar nenhum documento físico. Mas não se preocupe! Ao fazer a opção de trocar de contador para a Conube, nossos especialistas vão indicar cada passo que precisará ser feito.',
  },
  {
    title: 'Qual o diferencial da Conube em comparação com outras contabilidades?',
    description: <>
      O grande diferencial é o atendimento desde o processo de entrada, quando prestamos uma consultoria gratuita tirando diversas dúvidas técnicas e sobre empreendedorismo, até o dia a dia da operação em si. O principal objetivo da Conube é facilitar a vida dos empreendedores. Neste cenário, oferecemos conforto e praticidade, proporcionando ao cliente um dos bens mais preciosos a praticamente qualquer pessoa nos dias atuais: tempo!
      <br />
      <br />
      Fazemos isso utilizando a tecnologia a nosso favor, focando em desenvolver cada vez mais nosso sistema. Pensamos em proporcionar aos clientes sua melhor experiência com a nossa solução.
    </>,
  },
  {
    title: 'Como é feito o atendimento da Conube?',
    description: 'Pode ser feito via chat, e-mail, WhatsApp, vídeo-chamado ou até mesmo com um assessor especializado no seu segmento (dependendo do plano contratado). Desta forma conseguimos dar mais agilidade aos atendimentos.',
  },
  {
    title: 'Quais são as atividades e profissões que a Conube atende?',
    description: 'A Conube está pronta para atender empresas com atividades de prestação de serviços de todo o Brasil. Nossa solução foi feita sob medida para designers, programadores, corretores, consultores, arquitetos, engenheiros, médicos, freelancers e profissionais de pelo menos mais 100 outros segmentos.',
  },
  {
    title: 'O que eu precisarei fazer dentro do sistema de contabilidade online da Conube?',
    description: <>
      Como cliente da Conube, você terá apenas que emitir as notas fiscais e acompanhar o calendário de pagamento de impostos, baixando e efetuando os pagamentos conforme as datas indicadas (a plataforma manda avisos lembrando dos prazos).
      <br />
      <br />
      Além disso, outra ação importante será o preenchimento do fluxo de caixa dentro na nossa ferramenta. Consiste em importar seu extrato e classificar suas movimentações financeiras do mês. Isso será essencial para que nosso time possa fechar a contabilidade da sua empresa e ainda te ajudará a organizar seu controle financeiro.
    </>,
  },
  {
    title: 'Quais documentos fiscais e contábeis preciso enviar?',
    description: <>
      Para começarmos o processo, basta você enviar o número de CNPJ e o CPF, nome completo, e-mail e telefone.
      <br />
      <br />
      O resto é com a gente! Nossos especialistas solicitam os demais documentos necessários para a migração com o seu antigo contador. Tudo feito de forma gratuita.
    </>,
  },
  {
    title: 'Vou ser atendido por robôs pela Conube?',
    description: <>
      Não! Você sempre receberá o suporte de uma equipe de especialistas, contadores e consultores preparada para te ajudar no que for necessário.
      <br />
      <br />
      O atendimento pode ser feito via chat, e-mail, WhatsApp, telefone, vídeo-chamada ou com assessor especializado (dependendo do plano contratado).
    </>,
  },
];

function PatenerSession({ noButtons = false, color }) {
  const classes = useStyles({ color });
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const settings = {
    dots: true,
    infinite: isMobile,
    speed: 500,
    slidesToShow: isMobile ? 1 : 3,
    slidesToScroll: 1,
    arrows: false,
  };

  return (
    <>
      <Box style={{
        justifyContent: 'center', alignItems: 'center', display: 'flex', flexDirection: 'column',
      }}
      >
        <Slider className={isMobile ? classes.sliderMobile : classes.slider} {...settings}>
          <PatenerCard
            color={color}
            image={socio01Image}
            text="“A palavra é simplicidade! É tudo bem rápido e eu mesmo posso fazer e acompanhar as atividades da minha empresa através da própria plataforma. Com isso, também ganho muito tempo.”"
            onClick={() => { alert('teste'); }}
            name="Jane Queiroz"
            position="CEO | JQL Corretora"
          />
          <PatenerCard
            color={color}
            image={socio02Image}
            text="“Nossa vida, como empresa, se tornou muito mais simples e organizada. Podemos focar no negócio porque a parte burocrática está nas mãos de pessoas certas.”"
            onClick={() => { alert('teste'); }}
            name="Bruna Guimarães"
            position="Co-founder | GUPY"
          />
          <PatenerCard
            color={color}
            image={socio03Image}
            text="“Uma equipe competente, ágil e que me passa credibilidade e a segurança de que o serviço será bem feito. Hoje essa organização que a Conube nos proporciona pesa muito a nosso favor.”"
            onClick={() => { alert('teste'); }}
            name="Tatiana Pimenta"
            position="CEO | Vittude"
          />
          <PatenerCard
            color={color}
            image={socio04Image}
            text="“Minha experiência com a Conube tem sido excelente, marcada por agilidade e atenção.  A equipe transmite segurança e clareza em cada orientação. Tenho apoio constante e confiável, o que me traz tranquilidade para focar em outras prioridades.”"
            onClick={() => { alert('teste'); }}
            name="Raquel Tonin Hauschild"
            position="CEO | Newgen Consulting Ltda."
          />
          <PatenerCard
            color={color}
            image={socio05Image}
            text="“Abertura de empresa feita de forma rápida e eficiente. Emissão de notas de serviços na plataforma é realizada de forma simples. Indiquei para várias pessoas que estão plenamente satisfeitas como eu.”"
            onClick={() => { alert('teste'); }}
            name="Patrício Arriagada"
            position="CEO | Pa78"
          />
          <PatenerCard
            color={color}
            image={socio06Image}
            text="“Eu admiro a Conube por equilibrar tecnologia e contato humano. Ela me fornece a facilidade do digital alinhada ao contato próximo. É agilidade no dia a dia e uma conversa real quando preciso.”"
            name="Felipe Angelozzi"
            position="CEO | Bem Fácil"
            onClick={() => { alert('teste'); }}
          />
        </Slider>
        <div style={{ height: isMobile ? '68px' : '88px' }} />
        {!noButtons && (
          <Box style={{
            display: 'flex', gap: '24px', justifyContent: 'center', alignItems: 'center',
          }}
          >
            {!isMobile && (
            <StyledButton
              text="MIGRAR DE CONTABILIDADE"
              variant="outlined"
              component="a"
              href="/trocar-contador/"
              style={{
                width: '383px',
                BorderColor: '#0093F5',
                color: '#0093F5',
                border: '1px solid #0093F5',
              }}
            />
            )}
            <StyledButton
              text="VER NOSSOS PLANOS"
              variant="contained"
              component="a"
              href="/quanto-custa/"
              style={{
                width: '383px',
              }}
            />
          </Box>
        )}
      </Box>
    </>
  );
}

function FaqSession({ color }) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  return (
    <>
      <Typography style={{
        fontFamily: 'Nunito',
        fontWeight: 400,
        fontSize: '20px',
        color,
        textAlign: isMobile && 'center',
      }}
      >
        Perguntas frequentes
      </Typography>
      <Typography
        style={{
          fontFamily: 'Nunito',
          fontWeight: 400,
          padding: isMobile && '0 16px',
          fontSize: '31px',
          maxWidth: !isMobile && '282px',
          color: '#36344B',
          textAlign: isMobile && 'center',
        }}
        component="h2"
      >
        Ficou com dúvidas? A gente te ajuda!
      </Typography>
      <div style={{
        display: 'flex', justifyContent: isMobile ? 'center' : 'flex-end', marginRight: '36px', marginTop: isMobile ? '48px' : '20px', alignItems: isMobile && 'center', width: isMobile && '100%',
      }}
      >
        <img
          src={isMobile ? womanInOnlineMeetingsimageMobile : womanInOnlineMeetingsimage}
          alt="womanInOnlineMeetingsimage"
          style={{ height: isMobile ? '318px' : '353px', width: 'auto' }}
        />
      </div>
    </>
  );
}

const SwitchAccountant = () => {
  const { basic } = usePurpleFriday();
  const theme = useTheme();

  const tagFormHeaderDesktopWhatsApp = () => addTagFirebaseAnalytcs(tagsAnalytcs.btn_banner_trocar_desk_wpp);
  const tagFormHeaderDesktopPhone = () => addTagFirebaseAnalytcs(tagsAnalytcs.btn_banner_trocar_desk_ligar);
  const tagWhatsAppOpenCompanyDesktop = () => addTagFirebaseAnalytcs(tagsAnalytcs.btn_whats_icones_trocar_desk);
  const tagWhatsAppOpenCompanyFormDesktop = () => addTagFirebaseAnalytcs(tagsAnalytcs.btn_whats_icones_trocar_desk_form);

  const tagContratarOnline1Desktop = () => addTagFirebaseAnalytcs(tagsAnalytcs.btn_contrat1_trocar_online_desk);
  const tagContratarOnline1DesktopWpp = () => addTagFirebaseAnalytcs(tagsAnalytcs.btn_contrat1_trocar_online_desk_wpp);
  const tagContratarOnline1DesktopLigar = () => addTagFirebaseAnalytcs(tagsAnalytcs.btn_contrat1_trocar_online_desk_ligar);
  const tagContratarDigital1Desktop = () => addTagFirebaseAnalytcs(tagsAnalytcs.btn_contrat1_trocar_digital_desk);
  const tagContratarDigital1DesktopWpp = () => addTagFirebaseAnalytcs(tagsAnalytcs.btn_contrat1_trocar_digital_desk_wpp);
  const tagContratarDigital1DesktopLigar = () => addTagFirebaseAnalytcs(tagsAnalytcs.btn_contrat1_trocar_digital_desk_ligar);
  const tagContratarPrivate1Desktop = () => addTagFirebaseAnalytcs(tagsAnalytcs.btn_contrat1_trocar_private_desk);
  const tagContratarPrivate1DesktopWpp = () => addTagFirebaseAnalytcs(tagsAnalytcs.btn_contrat1_trocar_private_desk_wpp);
  const tagContratarPrivate1DesktopLigar = () => addTagFirebaseAnalytcs(tagsAnalytcs.btn_contrat1_trocar_private_desk_ligar);

  const tagContratarOnline2Desktop = () => addTagFirebaseAnalytcs(tagsAnalytcs.btn_contrat2_trocar_online_desk);
  const tagContratarOnline2DesktopWpp = () => addTagFirebaseAnalytcs(tagsAnalytcs.btn_contrat2_trocar_online_desk_wpp);
  const tagContratarOnline2DesktopLigar = () => addTagFirebaseAnalytcs(tagsAnalytcs.btn_contrat2_trocar_online_desk_ligar);
  const tagContratarDigital2Desktop = () => addTagFirebaseAnalytcs(tagsAnalytcs.btn_contrat2_trocar_digital_desk);
  const tagContratarDigital2DesktopWpp = () => addTagFirebaseAnalytcs(tagsAnalytcs.btn_contrat2_trocar_digital_desk_wpp);
  const tagContratarDigital2DesktopLigar = () => addTagFirebaseAnalytcs(tagsAnalytcs.btn_contrat2_trocar_digital_desk_ligar);
  const tagContratarPrivate2Desktop = () => addTagFirebaseAnalytcs(tagsAnalytcs.btn_contrat2_trocar_private_desk);
  const tagContratarPrivate2DesktopWpp = () => addTagFirebaseAnalytcs(tagsAnalytcs.btn_contrat2_trocar_private_desk_wpp);
  const tagContratarPrivate2DesktopLigar = () => addTagFirebaseAnalytcs(tagsAnalytcs.btn_contrat2_trocar_private_desk_ligar);

  const tagButtontrocarFeatureDesk = () => addTagFirebaseAnalytcs(tagsAnalytcs.btn_baixo_trocar_desk);
  const tagButtontrocarFeatureDeskWpp = () => addTagFirebaseAnalytcs(tagsAnalytcs.btn_baixo_trocar_desk_wpp);
  const tagButtontrocarFeatureDeskLigar = () => addTagFirebaseAnalytcs(tagsAnalytcs.btn_baixo_trocar_desk_ligar);

  const tagFormHeaderMobileWhatsApp = () => addTagFirebaseAnalytcs(tagsAnalytcs.btn_banner_trocar_mob_wpp);
  const tagFormHeaderMobilePhone = () => addTagFirebaseAnalytcs(tagsAnalytcs.btn_banner_trocar_mob_ligar);
  const tagWhatsappMobile = () => addTagFirebaseAnalytcs(tagsAnalytcs.btn_whats_icones_trocar_mob);
  const tagWhatsappMobileForm = () => addTagFirebaseAnalytcs(tagsAnalytcs.btn_whats_icones_trocar_mob_form);
  const tagQUeroTrocarMobile = () => addTagFirebaseAnalytcs(tagsAnalytcs.btn_queromigrar_trocar_mob);
  const tagQUeroTrocarMobileLigar = () => addTagFirebaseAnalytcs(tagsAnalytcs.btn_queromigrar_trocar_mob_ligar);
  const tagQUeroTrocarMobileWpp = () => addTagFirebaseAnalytcs(tagsAnalytcs.btn_queromigrar_trocar_mob_wp);

  const tagContratarOnlineMobile = () => addTagFirebaseAnalytcs(tagsAnalytcs.btn_contrat_trocar_online_mob);
  const tagContratarOnlineMobileWpp = () => addTagFirebaseAnalytcs(tagsAnalytcs.btn_contrat_trocar_online_mob_wpp);
  const tagContratarOnlineMobileLigar = () => addTagFirebaseAnalytcs(tagsAnalytcs.btn_contrat_trocar_online_mob_ligar);
  const tagWppOnlineMobileLigar = () => addTagFirebaseAnalytcs(tagsAnalytcs.btn_whats_trocar_online_mob);
  const tagWppOnlineMobileLigarForm = () => addTagFirebaseAnalytcs(tagsAnalytcs.btn_whats_trocar_online_mob_form);

  const tagContratarDigitalMobile = () => addTagFirebaseAnalytcs(tagsAnalytcs.btn_contrat_trocar_digital_mob);
  const tagContratarDigitalMobileWpp = () => addTagFirebaseAnalytcs(tagsAnalytcs.btn_contrat_trocar_digital_mob_wpp);
  const tagContratarDigitalMobileLigar = () => addTagFirebaseAnalytcs(tagsAnalytcs.btn_contrat_trocar_digital_mob_ligar);
  const tagWppDigitalMobileLigar = () => addTagFirebaseAnalytcs(tagsAnalytcs.btn_whats_trocar_digital_mob);
  const tagWppDigitalMobileLigarForm = () => addTagFirebaseAnalytcs(tagsAnalytcs.btn_whats_trocar_digital_mob_form);

  const tagContratarPrivateMobile = () => addTagFirebaseAnalytcs(tagsAnalytcs.btn_contrat_trocar_private_mob);
  const tagContratarPrivateMobileWpp = () => addTagFirebaseAnalytcs(tagsAnalytcs.btn_contrat_trocar_private_mob_wpp);
  const tagContratarPrivateMobileLigar = () => addTagFirebaseAnalytcs(tagsAnalytcs.btn_contrat_trocar_private_mob_ligar);
  const tagWppPrivateMobileLigar = () => addTagFirebaseAnalytcs(tagsAnalytcs.btn_whats_trocar_private_mob);
  const tagWppPrivateMobileLigarForm = () => addTagFirebaseAnalytcs(tagsAnalytcs.btn_whats_trocar_private_mob_form);

  const tagSliderMobile = () => addTagFirebaseAnalytcs(tagsAnalytcs.btn_dep_trocar_mob);
  const tagSliderMobileWpp = () => addTagFirebaseAnalytcs(tagsAnalytcs.btn_dep_trocar_mob_wpp);
  const tagSliderMobileLigar = () => addTagFirebaseAnalytcs(tagsAnalytcs.btn_dep_trocar_mob_ligar);

  const tagFaqMobile = () => addTagFirebaseAnalytcs(tagsAnalytcs.btn_faq_trocar_mob);
  const tagFaqMobileWpp = () => addTagFirebaseAnalytcs(tagsAnalytcs.btn_faq_trocar_mob_wpp);
  const tagFaqMobileLigar = () => addTagFirebaseAnalytcs(tagsAnalytcs.btn_faq_trocar_mob_ligar);

  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  useEffect(() => {
    (function (w, d, s, l, i) {
      w[l] = w[l] || []; w[l].push({
        'gtm.start':
          new Date().getTime(),
        event: 'gtm.js',
      }); const f = d.getElementsByTagName(s)[0];
      const j = d.createElement(s); const dl = l != 'dataLayer' ? `&l=${l}` : ''; j.async = true;
      j.src = `https://www.googletagmanager.com/gtm.js?id=${i}${dl}`;
      f.parentNode.insertBefore(j, f);
    }(window, document, 'script', 'dataLayer', 'GTM-WMXRPTFS'));
  }, []);

  return (
    <>
      {isMobile ? <SwitchAccountantHeroMobile tagFormHeaderMobileWhatsApp={tagFormHeaderMobileWhatsApp} tagFormHeaderMobilePhone={tagFormHeaderMobilePhone} tagFormHeaderMobileWhatsAppId="btn_banner_trocar_mob_wpp" tagFormHeaderMobilePhoneId="btn_banner_trocar_mob_ligar" /> : <SwitchAccountantHero btnWppTag={tagFormHeaderDesktopWhatsApp} btnLigarTag={tagFormHeaderDesktopPhone} btnWppTagId="btn_banner_trocar_desk_wpp" btnLigarTagId="btn_banner_trocar_desk_ligar" />}

      <FeaturesSectionSwitchAccountant tagWhatsappMobileForm={tagWhatsappMobileForm} tagWhatsappMobile={tagWhatsappMobile} tagWhatsAppOpenCompanyDesktop={tagWhatsAppOpenCompanyDesktop} tagWhatsAppOpenCompanyFormDesktop={tagWhatsAppOpenCompanyFormDesktop} tagWhatsappMobileFormId="btn_whats_icones_trocar_mob_form" tagWhatsappMobileId="btn_whats_icones_trocar_mob" tagWhatsAppOpenCompanyDesktopId="btn_whats_icones_trocar_desk" tagWhatsAppOpenCompanyFormDesktopId="btn_whats_icones_trocar_desk_form" />

      <StepByStepSection
        background="#EAFFFC"
        color="#0CB49D"
        title={<><strong>Troque de contabilidade</strong> quando quiser!</>}
        subtitle={<>Você pode trocar de contador a qualquer momento do ano, <strong>sem nenhum custo.</strong></>}
        cards={[
          { title: 'Preencha o formulário!', text: <>Nosso time fará uma <strong>revisão completa</strong> do cenário atual contábil e fiscal da sua empresa.</> },
          { title: <>Escolha um dos nossos planos</>, text: <><strong>Selecione a melhor opção</strong> e faça o envio de documentos com toda a segurança na nossa plataforma.</> },
          { title: 'Siga a sua jornada empreendedora!', text: <><strong>Prontinho!</strong> Agora você foca no seu negócio, enquanto cuidamos da parte contábil da sua empresa.</> },
        ]}
      />

      {!isMobile && <Grid item md={12} lg={12} xl={12} sm={12} xs={12} style={{ height: '30px', backgroundColor: '#F4F4F7' }} />}
      <ButtonSwitchAccountantSectionMobile
        tagSliderMobile={tagQUeroTrocarMobile}
        tagSliderMobileLigar={tagQUeroTrocarMobileLigar}
        tagSliderMobileWpp={tagQUeroTrocarMobileWpp}
        tagSliderMobileId="btn_queromigrar_trocar_mob"
        tagSliderMobileLigarId="btn_queromigrar_trocar_mob_ligar"
        tagSliderMobileWppId="btn_queromigrar_trocar_mob_wp"
      />
      <PlansCard
        tagContratarOnline1Desktop={() => { tagContratarOnline1Desktop(); }}
        tagContratarOnline1DesktopWpp={() => { tagContratarOnline1DesktopWpp(); }}
        tagContratarOnline1DesktopLigar={() => { tagContratarOnline1DesktopLigar(); }}
        tagContratarDigital1Desktop={() => { tagContratarDigital1Desktop(); }}
        tagContratarDigital1DesktopWpp={() => { tagContratarDigital1DesktopWpp(); }}
        tagContratarDigital1DesktopLigar={() => { tagContratarDigital1DesktopLigar(); }}
        tagContratarPrivate1Desktop={() => { tagContratarPrivate1Desktop(); }}
        tagContratarPrivate1DesktopWpp={() => { tagContratarPrivate1DesktopWpp(); }}
        tagContratarPrivate1DesktopLigar={() => { tagContratarPrivate1DesktopLigar(); }}
        tagContratarOnline2Desktop={() => { tagContratarOnline2Desktop(); }}
        tagContratarOnline2DesktopWpp={() => { tagContratarOnline2DesktopWpp(); }}
        tagContratarOnline2DesktopLigar={() => { tagContratarOnline2DesktopLigar(); }}
        tagContratarDigital2Desktop={() => { tagContratarDigital2Desktop(); }}
        tagContratarDigital2DesktopWpp={() => { tagContratarDigital2DesktopWpp(); }}
        tagContratarDigital2DesktopLigar={() => { tagContratarDigital2DesktopLigar(); }}
        tagContratarPrivate2Desktop={() => { tagContratarPrivate2Desktop(); }}
        tagContratarPrivate2DesktopWpp={() => { tagContratarPrivate2DesktopWpp(); }}
        tagContratarPrivate2DesktopLigar={() => { tagContratarPrivate2DesktopLigar(); }}
        tagContratarOnlineMobile={() => { tagContratarOnlineMobile(); }}
        tagContratarOnlineMobileWpp={() => { tagContratarOnlineMobileWpp(); }}
        tagContratarOnlineMobileLigar={() => { tagContratarOnlineMobileLigar(); }}
        tagWppOnlineMobileLigar={() => { tagWppOnlineMobileLigar(); }}
        tagContratarDigitalMobile={() => { tagContratarDigitalMobile(); }}
        tagContratarDigitalMobileWpp={() => { tagContratarDigitalMobileWpp(); }}
        tagContratarDigitalMobileLigar={() => { tagContratarDigitalMobileLigar(); }}
        tagWppDigitalMobileLigar={() => { tagWppDigitalMobileLigar(); }}
        tagContratarPrivateMobile={() => { tagContratarPrivateMobile(); }}
        tagContratarPrivateMobileWpp={() => { tagContratarPrivateMobileWpp(); }}
        tagContratarPrivateMobileLigar={() => { tagContratarPrivateMobileLigar(); }}
        tagWppPrivateMobileLigar={() => { tagWppPrivateMobileLigar(); }}
        tagWppOnlineMobileLigarForm={() => tagWppOnlineMobileLigarForm()}
        tagWppDigitalMobileLigarForm={() => { tagWppDigitalMobileLigarForm(); }}
        tagWppPrivateMobileLigarForm={() => { tagWppPrivateMobileLigarForm(); }}
        tagContratarOnline1DesktopWppId="btn_contrat1_trocar_online_desk_wpp"
        tagContratarOnline1DesktopLigarId="btn_contrat1_trocar_online_desk_ligar"
        tagContratarDigital1DesktopWppId="btn_contrat1_trocar_digital_desk_wpp"
        tagContratarDigital1DesktopLigarId="btn_contrat1_trocar_digital_desk_ligar"
        tagContratarPrivate1DesktopWppId="btn_contrat1_trocar_private_desk_wpp"
        tagContratarPrivate1DesktopLigarId="btn_contrat1_trocar_private_desk_ligar"
        tagContratarOnline2DesktopWppId="btn_contrat2_trocar_online_desk_wpp"
        tagContratarOnline2DesktopLigarId="btn_contrat2_trocar_online_desk_ligar"
        tagContratarDigital2DesktopWppId="btn_contrat2_trocar_digital_desk_wpp"
        tagContratarDigital2DesktopLigarId="btn_contrat2_trocar_digital_desk_ligar"
        tagContratarPrivate2DesktopWppId="btn_contrat2_trocar_private_desk_wpp"
        tagContratarPrivate2DesktopLigarId="btn_contrat2_trocar_private_desk_ligar"
        tagContratarOnlineMobileWppId="btn_contrat_trocar_online_mob_wpp"
        tagContratarOnlineMobileLigarId="btn_contrat_trocar_online_mob_ligar"
        tagContratarDigitalMobileWppId="btn_contrat_trocar_digital_mob_wpp"
        tagContratarDigitalMobileLigarId="btn_contrat_trocar_digital_mob_ligar"
        tagContratarPrivateMobileWppId="btn_contrat_trocar_private_mob_wpp"
        tagContratarPrivateMobileLigarId="btn_contrat_trocar_private_mob_ligar"
        hover="#09796A"
        disabled="#BFD9D5"
        page="switch-accountant"
        themeType={basic}
        color="#0CB49D"
      />

      {isMobile ? (
        <MobileHowMuchSlider tagSliderMobile={tagSliderMobile} tagSliderMobileLigar={tagSliderMobileLigar} tagSliderMobileWpp={tagSliderMobileWpp} tagSliderMobileId="btn_dep_trocar_mob" tagSliderMobileLigarId="btn_dep_trocar_mob_ligar" tagSliderMobileWppId="btn_dep_trocar_mob_wpp" noBottonSpacing textButton="TROCAR DE CONTABILIDADE" color="#0CB49D" hover="#09796A" disabled="#BFD9D5" />
      ) : (
        <AccountingFeature buttonTagWpp={tagButtontrocarFeatureDeskWpp} buttonTagPhone={tagButtontrocarFeatureDeskLigar} buttonTag={tagButtontrocarFeatureDesk} buttonTagWppId="btn_baixo_trocar_desk_wpp" buttonTagPhoneId="btn_baixo_trocar_desk_ligar" buttonTagId="btn_baixo_trocar_desk" color="#0CB49D" colorButton="#09796A" />
      )}

      <ContentWrap>
        <Grid item md={12} lg={12} xl={12} sm={12} xs={12}>
          {!isMobile && (
            <TextWithButtonSession
              mainText={(
                <>
                  Ajudamos
                  {' '}
                  <strong style={{ color: '#0CB49D' }}>milhares de empreendedores</strong>
                  {' '}
                  em todo o Brasil!
                </>
              )}
            />
          )}

          {isMobile && (
            <TextWithButtonSession
              mainText={(
                <>
                  Ajudamos
                  {' '}
                  <strong style={{ color: '#0CB49D' }}>milhares<br /> de empreendedores</strong> em todo o Brasil!
                </>
              )}
            />
          )}
          <div style={{ height: '33px' }} />
          <PatenerSession
            color="#0CB49D"
            noButtons
          />
        </Grid>
      </ContentWrap>

      {isMobile && (
      <ModalSwitchAccountant
        tagFaqMobile={tagFaqMobile}
        tagFaqMobileLigar={tagFaqMobileLigar}
        tagFaqMobileWpp={tagFaqMobileWpp}
        tagFaqMobileId="btn_faq_trocar_mob"
        tagFaqMobileLigarId="btn_faq_trocar_mob_ligar"
        tagFaqMobileWppId="btn_faq_trocar_mob_wpp"
      />
      )}

      <ContentWrap>
        <Grid container spacing={2}>
          <Grid item md={5} lg={5} xl={5} sm={12} xs={12} style={{ paddingLeft: '0px', padding: isMobile && '0px 25px 35px' }}>
            <FaqSession color="#0CB49D" />
          </Grid>
          <Grid item md={7} lg={7} xl={7} sm={12} xs={12}>
            <AccordeonList renderList={renderList} color="#0CB49D" />
          </Grid>
        </Grid>
      </ContentWrap>
      <Grid item md={12} lg={12} xl={12} sm={12} xs={12} style={{ height: isMobile ? '84px' : '40px' }} />
    </>
  );
};

export default SwitchAccountant;
